<template>
  <!-- //ROUTER IF MOBILE -->
  <ion-content class="d-flex wrapper" v-if="isMobile">
      <div class="block block__challenges">
        <SidebarChallenges class="desktop" />
          <transition  
            name="fade"
          >
            <router-view></router-view>
          </transition>
      </div>
  </ion-content> 
  <!-- //ROUTER IF MOBILE -->

  <!-- //ROUTER IF DESKTOP -->
  <b-overlay
    id="overlay-challenge"
    :show="show"
    rounded="sm"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    v-else
  >    
    <section class="d-flex wrapper" >
      <SidebarChallenges @showloader="showLoader"/>
      <div class="block block__challenges">
          <transition  
            name="fade"
            mode="in-out"
          >
            <router-view></router-view>
          </transition>
      </div>
    </section> 
  </b-overlay>
  <!-- //ROUTER IF DESKTOP -->
</template>



<script>
import SidebarChallenges from '../../module/sidebar/SidebarChallenges'
import { mapGetters } from 'vuex'
import CatMixin from './CatMixin'
// import utils from '../../Utils'


export default {
  name:"challenges",
    components:{
        SidebarChallenges,
    }, 
    mixins: [
      CatMixin 
    ],       
  data () {
    return {
        isMobile:false,
        show: false
    }
  },
  computed: {
    ...mapGetters([
    ])
  },
  created(){
    window.addEventListener('wheel', this.handleScroll);
  },
  activated() {
    window.addEventListener('wheel', this.handleScroll);
  },
  deactivated() {
    window.removeEventListener('wheel', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('wheel', this.handleScroll);
  },
  methods:{
    showLoader:function (e){
      this.show = !e ? true : false;
    },
    handleScroll (event) {
      var container = this.$el.querySelector(".block__challenges");
      if (container){
        container.scrollTop += event.deltaY;
      }

      container = this.$el.querySelector(".sidebarChallenges");
      if (container){
        container.scrollTop += event.deltaY;
      }

      container = this.$el.querySelector(".block__challengesAccueil");
      if (container){
        container.scrollTop += event.deltaY;
      }

      container = this.$el.querySelector(".column-middle");
      if (container){
        container.scrollTop += event.deltaY;
      }

      container = this.$el.querySelector(".column-right");
      if (container){
        container.scrollTop += event.deltaY;
      }
    }
  }
};
</script>
